"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var api_request_1 = require("../api_request");
var alt_1 = require("../alt");
var RailsViewActionsBase = /** @class */ (function (_super) {
    tslib_1.__extends(RailsViewActionsBase, _super);
    function RailsViewActionsBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RailsViewActionsBase.prototype.setHTML = function (html) {
        return html;
    };
    RailsViewActionsBase.prototype.fetchHTML = function (url, params) {
        var _this = this;
        api_request_1.V3.get(url, params).then(function (resp) {
            _this.setHTML(resp);
        }).fail(function (_xhr, status, err) {
            throw new Error("failed to fetch rails view - status: " + status + ", err: " + err);
        });
        return null;
    };
    RailsViewActionsBase.prototype.clearHTML = function () {
        return true;
    };
    return RailsViewActionsBase;
}(alt_1.AltActions));
exports.RailsViewActions = alt_1.default.createActions(RailsViewActionsBase);
var RailsViewStoreBase = /** @class */ (function (_super) {
    tslib_1.__extends(RailsViewStoreBase, _super);
    function RailsViewStoreBase() {
        var _this = _super.call(this) || this;
        _this.html = null;
        _this.bindActions(exports.RailsViewActions);
        return _this;
    }
    RailsViewStoreBase.prototype.onSetHTML = function (response) {
        this.setState({ html: response });
    };
    RailsViewStoreBase.prototype.onClearHTML = function () {
        this.setState({ html: null });
    };
    return RailsViewStoreBase;
}(alt_1.AltStoreModel));
exports.RailsViewStore = alt_1.default.createStore(RailsViewStoreBase, 'RailsViewStore');
//# sourceMappingURL=rails_view_store.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/rails_view_store.js
// module id = pEr0
// module chunks = 20 21